<template>
  <div class="game" :class="{'animate': useAnimations}">
    <header>
      <div class="combo">
        <div class="center">
          <p>Damage</p>
          x{{damage}}
          <!--<span>{{damage + comboDamage}}</span>-->
        </div>
      </div>
      <div class="level" @click="showLevel = !showLevel">
        <p>{{centerHeader}}</p>
        {{centerValue}}
        <!--<span>({{score}})</span>-->
      </div>
      <div class="clicks-left">
        <div class="center">
          <p>Taps</p>
          {{clicksLeft}}
        </div>
      </div>
      <div class="combo-progress-wrapper">
        <div class="progress" :style="{'width': `${comboPercentage}%`}"></div>
      </div>
      <div class="combo-points-progress">
        {{this.multiplierMeter}} / {{this.comboNeededToLevelUp}}
      </div>
    </header>
    <div class="board">
      <Tile v-for="tile in tiles" v-bind:tile="tile" :damage="damage" :color="tileColor" v-bind:key="tile.id" @longPress="longPress" @hitClick="startChainReaction(tile)"></Tile>
    </div>
    <footer>
      <p class="small-header">Power ups</p>
      <div class="power-ups">
        <div class="power-up-wrapper" v-for="powerup in powerUps.filter(x => x.show)" :key="powerup.id">
          <button class="power-up" :disabled="powerup.amount < 1" @click="selectPowerUp(powerup)" :class="{'active': activePowerUp && powerup.id === activePowerUp.id}">
            <i class="fas fa-fw" :class="powerup.icon"></i>
            <span class="badge">{{powerup.amount}}</span>
          </button>
        </div>
      </div>
    </footer>
    <div class="new-power-up-wrapper" :class="{'show': test.id > -1}">
      <div class="new-power-up">
        <h3 class="new-power-up-name">New power up!</h3>

        <div class="new-power-up-image">

          <i class="fas fa-fw" :class="test.icon"></i>
        </div>

        <h3 class="new-power-up-name">{{test.name}}</h3>
      </div>
    </div>

    <RetryMenu v-if="gameOver" :score="score" :runningInApp="runningInApp" @retry="reset" @reward="reward" :alreadyRewarded="alreadyRewarded"></RetryMenu>

  </div>
</template>

<script>
import ComboGame from 'combo-logic';
import Tile from '@/components/Tile';
import RetryMenu from '@/components/RetryMenu';
import storage from 'local-storage-fallback';

export default {
  name: 'game',
  components: { Tile, RetryMenu },
  props: {
    client: Object,
    highscoreRoom: Object,
    playerName: String,
    useAnimations: Boolean,
    runningInApp: Boolean,
  },
  data() {
    return {
      activePowerUp: null,
      newPowerUp: null,
      columns: 7,
      damage: 1,
      clicksLeft: 20,
      score: 0,
      level: 1,
      combo: 0,
      tiles: [],
      hits: 0,
      highscore: 0,
      events: 0,
      speed: 250,
      multiplierMeter: 0,
      clicksPerLevel: 20,
      showStart: true,
      showHighscore: false,
      comboNeededToLevelUp: 200,
      tileColor: 're',
      changePlayerName: false,
      shouldSetUserName: false,
      game: null,
      totalCombo: 0,
      showLevel: false,
      alreadyRewarded: false,
      powerUps: [{
        id: 0,
        key: 'bomb',
        icon: 'fa-bomb',
        name: 'Bomb',
        show: true,
        amount: 0,
      }, {
        id: 1,
        key: 'clear_vert',
        icon: 'fa-arrows-alt-v',
        name: 'Remove vertical',
        show: true,
        amount: 0,
      }, {
        id: 2,
        key: 'clear_hor',
        icon: 'fa-arrows-alt-h',
        name: 'Remove horizontal',
        show: true,
        amount: 0,
      }, {
        id: 3,
        key: 'clear_both',
        icon: 'fa-arrows-alt',
        name: 'Remove up-down',
        show: true,
        amount: 0,
      }, {
        id: 4,
        key: 'extra_taps',
        icon: 'fa-hand-pointer',
        name: 'Taps +10',
        show: false,
        amount: 0,
      }],
    };
  },
  mounted() {
    this.tileColor = (storage.getItem('tileColor') || 're');
    this.game = new ComboGame(this.level, this.columns, this.tileColor);
    this.highscore = parseFloat(storage.getItem('highscore') || 0);

    const tiles = this.game.newGame(this.level);
    this.tiles.push(...tiles);
  },
  methods: {
    longPress(tile) {
      if (!tile.alive) return;
      if (tile.health <= this.clicksLeft) {
        this.clicksLeft -= tile.health;
        this.hit(tile, true, true);
      }
    },
    rewardWithPowerUp() {
      const index = this.randomBetween(0, (this.powerUps.length - 1));
      const powerUp = this.powerUps[index];
      if (powerUp) {
        this.newPowerUp = powerUp;

        if (powerUp.key === 'extra_taps') {
          this.clicksLeft += 10;
        } else {
          powerUp.amount += 1;
        }

        setTimeout(() => {
          this.newPowerUp = null;
        }, 1200);
      }
    },
    randomBetween(min, max) {
      return Math.floor(Math.random()*(max-min+1)+min); //eslint-disable-line
    },
    selectPowerUp(powerUp) {
      if (this.activePowerUp && this.activePowerUp.id === powerUp.id) {
        this.activePowerUp = null;
        return;
      }
      this.activePowerUp = powerUp;
    },
    reward() {
      if (!this.alreadyRewarded) {
        this.clicksLeft += 20;
        this.alreadyRewarded = true;
      }
    },
    findSurrounding(position) {
      const above = this.getTileByPosition({ row: (position.row - 1), column: position.column });
      const below = this.getTileByPosition({ row: (position.row + 1), column: position.column });
      const left = this.getTileByPosition({ row: (position.row), column: position.column - 1 });
      const right = this.getTileByPosition({ row: (position.row), column: position.column + 1 });
      if (above) {
        this.hits += 1;
        setTimeout(() => {
          this.hit(above, true);
        }, this.speed);
      }
      if (below) {
        this.hits += 1;
        setTimeout(() => {
          this.hit(below, true);
        }, this.speed);
      }
      if (left) {
        this.hits += 1;
        setTimeout(() => {
          this.hit(left, true);
        }, this.speed);
      }
      if (right) {
        this.hits += 1;
        setTimeout(() => {
          this.hit(right, true);
        }, this.speed);
      }
    },
    startChainReaction(tile) {
      if (!tile.alive || this.clicksLeft < 1) {
        return;
      }

      if (this.activePowerUp !== null) {
        this.combo = 0;
        if (this.activePowerUp.key === 'bomb') {
          this.activateBomb(tile);
        }
        if (this.activePowerUp.key === 'clear_vert') {
          this.clearVert(tile);
        }
        if (this.activePowerUp.key === 'clear_hor') {
          this.clearHor(tile);
        }
        if (this.activePowerUp.key === 'clear_both') {
          this.clearBoth(tile);
        }
        this.activePowerUp.amount -= 1;
        this.activePowerUp = null;
        return;
      }

      this.clicksLeft -= 1;
      this.events = 0;
      this.hits += 2;
      this.combo = 0;
      // if (window.navigator) {
      //   window.navigator.vibrate(5);
      // }
      this.hit(tile, false);
    },
    activateBomb(startTile) {
      const above = this.getTileByPosition({ row: (startTile.position.row - 1),
        column: startTile.position.column });
      const below = this.getTileByPosition({ row: (startTile.position.row + 1),
        column: startTile.position.column });
      const left = this.getTileByPosition({ row: (startTile.position.row),
        column: startTile.position.column - 1 });
      const right = this.getTileByPosition({ row: (startTile.position.row),
        column: startTile.position.column + 1 });

      const hitValue = Math.floor(startTile.health / 2);
      if (above) { this.hit(above, false, false, hitValue); }
      if (below) { this.hit(below, false, true, hitValue); }
      if (left) { this.hit(left, false, true, hitValue); }
      if (right) { this.hit(right, false, true, hitValue); }

      this.hit(startTile, false, true);
    },
    clearVert(startTile) {
      const tiles = this.tiles.filter(x => x.position.column === startTile.position.column &&
        x.alive);
      tiles.forEach(tile => this.hit(tile, false, true));
    },
    clearHor(startTile) {
      const tiles = this.tiles.filter(x => x.position.row === startTile.position.row && x.alive);
      tiles.forEach(tile => this.hit(tile, false, true));
    },
    clearBoth(startTile) {
      const tiles = this.tiles.filter(x => (x.position.row === startTile.position.row ||
        x.position.column === startTile.position.column) && x.alive);
      tiles.forEach(tile => this.hit(tile, false, true));
    },
    hit(tile, combo, kill, hitValue) {
      if (tile.alive) {
        tile.health -= this.damage; //eslint-disable-line

        if (kill) {
          tile.health = 0; //eslint-disable-line
        }

        if (hitValue) {
          tile.health -= hitValue; //eslint-disable-line
        }

        if (tile.health <= 0) {
          tile.alive = false; //eslint-disable-line
          tile.health = 0;//eslint-disable-line
          // tile.audio.play();
          // document.getElementById('pop').play();

          this.combo += 1;
          this.events += 1;
          this.score += 1;
          // if (this.combo >= 3) {
          tile.bonusPoint = this.combo; //eslint-disable-line
          this.multiplierMeter += this.combo;
          //          }

          if (tile.multiplier !== 1) {
            if (tile.multiplier === -1) {
              this.rewardWithPowerUp();
            } else {
              this.damage += tile.multiplier;
            }
          }
          this.findSurrounding(tile.position);
        }
      }
      this.hits -= (combo ? 1 : 2);
    },
    reportScore() {
      // this.highscoreRoom.send({ name: this.playerName, score: this.score });
      starx.notify('world.reportscore', { name: this.playerName, score: parseInt(this.score), isFinal: false }); //eslint-disable-line
      if (window.webkit) {
        try {
          console.log('sending score to ios app', this.score);
          window.webkit.messageHandlers.scoreHandler.postMessage(this.score);
        } catch (err) {
          console.log('The native context does not exist yet');
        }
      }
    },
    reset() {
      this.damage = 1;
      this.clicksLeft = this.clicksPerLevel;
      this.score = 0;
      this.level = 1;
      this.multiplierMeter = 0;
      this.combo = 0;
      this.events = 0;
      this.alreadyRewarded = false;
      this.setAllAsAlive();
      ga('send', 'event', 'Game', 'New'); //eslint-disable-line
    },
    setAllAsAlive() {
      this.game.setAllAsAlive(this.tiles, this.level);
    },
    getTileByPosition(position) {
      return this.tiles.find(tile => tile.position.row === position.row &&
        tile.position.column === position.column);
    },
  },
  computed: {
    test() {
      if (this.newPowerUp !== null) return this.newPowerUp;
      return { id: -1, key: '', icon: '', name: '' };
    },
    centerHeader() {
      return this.showLevel ? 'Level' : `Best: ${this.highscore}`;
    },
    centerValue() {
      return this.showLevel ? this.level : this.score;
    },
    totalHealth() {
      let health = 0;
      this.tiles.forEach((tile) => {
        health += tile.health;
      });
      return health;
    },
    allDead() {
      return this.tiles.find(tile => tile.alive) === undefined;
    },
    comboPercentage() {
      return Math.round(this.multiplierMeter / (this.comboNeededToLevelUp / 100));
    },
    gameEnded() {
      return (this.clicksLeft <= 0 && this.hits === 0);
    },
    gameOver() {
      return (this.clicksLeft <= 0 && this.hits === 0 && !this.allDead);
    },
  },
  watch: {
    totalHealth(health) {
      if (health === 0) {
        setTimeout(() => {
          if (this.combo > 3) {
            this.score += (this.combo * 2);
          }

          if (this.combo >= this.tiles.length) {
            this.score += 50;
            this.rewardWithPowerUp();
          }

          this.score += (this.clicksLeft * 2);
          this.level += 1;
          this.clicksLeft += this.clicksPerLevel;
          this.damage = 1;
          this.combo = 0;

          this.reportScore();

          this.setAllAsAlive();
        }, (this.speed * 2));
      }
    },
    combo(combo) {
      this.totalCombo += combo;
    },
    multiplierMeter(value) {
      if (value >= this.comboNeededToLevelUp) {
        this.multiplierMeter -= this.comboNeededToLevelUp;
        this.damage += 1;
      }
    },
    hits(value) {
      if (value === 0 && this.clicksLeft === 0) {
        ga('send', 'event', 'Game', 'Finished', 'Level', this.level); //eslint-disable-line
      }
    },
    score() {
      if (this.score > this.highscore) {
        this.highscore = this.score;
      }
    },
    gameOver(gameOver) {
      if (gameOver) {
        const scoreToReport = this.score;
        ga('send', 'event', 'Game', 'Finished', 'Score', scoreToReport); //eslint-disable-line
        starx.notify('world.reportscore', //eslint-disable-line 
          { name: this.playerName, score: parseInt(scoreToReport, 10), isFinal: true });
      }
    },
    highscore() {
      storage.setItem('highscore', this.highscore);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.combo-points-progress {
  font-size: 1rem;
  padding: 0 0.1rem;
  text-align: center;
  background: #262626;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -0.3rem;
}

footer {
  padding: 1rem;
}

.power-ups {
  display: flex;
  align-items: center;
  margin-left: -5px;
  margin-right: -5px;
}

.power-up-wrapper {
  padding: 0 5px;
}

.small-header {
  text-transform: uppercase;
  font-size: 0.7rem;
  margin: 0;
  margin-bottom: 10px;
}

.power-up {
  width: 40px;
  height: 40px;
  background: transparent;
  border-radius: 50%;
  box-shadow: none;
  border: 2px solid #fff;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &.active {
    background: #fff !important;
    i {
      color: #262626;
    }
  }

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  &:disabled {
    opacity: 0.2;
    cursor: default;

    &:hover {
      background: transparent;
    }
  }
  .badge {
    position: absolute;
    font-size: 10px;
    color: #262626;
    background: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    top: -6px;
    right: -7px;
    border: 2px solid #262626;
    font-family: 'Raleway', 'Open Sans', sans-serif;
    font-weight: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
  }
  i {
    font-size: 20px;
  }
}

.new-power-up-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: fade(#262626, 50%);
  opacity: 0;
  visibility: hidden;

  &.show {
    opacity: 1;
    visibility: visible;

    .new-power-up {
      transform: scale(1) !important;
    }
  }
}
.new-power-up {
  transform: scale(0);
}
.new-power-up,
.new-power-up-wrapper {
  transition: all ease 0.3s;
}

.new-power-up-name {
  font-size: 35px;
  text-align: center;
  text-transform: uppercase;
  margin: 10px 0;
}

.new-power-up-image {
  background: #fff;
  color: #262626;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 200px;
  width: 200px;
  margin: 0 auto;

  i {
    font-size: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// Game.vue?172fb116